import { render, staticRenderFns } from "./ReferralReportSection.vue?vue&type=template&id=5ef789db&scoped=true"
import script from "./ReferralReportSection.vue?vue&type=script&lang=js"
export * from "./ReferralReportSection.vue?vue&type=script&lang=js"
import style0 from "./ReferralReportSection.vue?vue&type=style&index=0&id=5ef789db&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef789db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef789db')) {
      api.createRecord('5ef789db', component.options)
    } else {
      api.reload('5ef789db', component.options)
    }
    module.hot.accept("./ReferralReportSection.vue?vue&type=template&id=5ef789db&scoped=true", function () {
      api.rerender('5ef789db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/one-part-a/components/ReferralReportSection.vue"
export default component.exports